import { styled } from '@clickcease/cc-client-components-lib'

export const InputContainer = styled('div', {
  backgroundColor: '$offWhite',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: '9px',
  borderRadius: '7px',

  '&:focus-within': {
    border: '1px solid $primaryColor',
    boxShadow: '$inputShadow',
    padding: '$4',
    backgroundColor: 'white',
  },

  '&:hover': {
    border: '1px solid $primaryColor',
    padding: '$4',
  },
})

export const IconContainer = styled('span', {
  width: '14px',
  height: '14px',
  marginInline: '10px',
  display: 'flex',

  '&:svg': {
    color: '$disabled',
  },
})

export const Input = styled('input', {
  all: 'unset',
  width: '100%',
  background: 'transparent',
  fontSize: '$md',
  color: '$textColor',

  '&::placeholder': {
    color: '$disabled',
  },
})
